<template>
  <div>
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false">Close</v-btn>
    </v-snackbar>

    <ClientNav />

    <v-container fluid>
      <v-row dense>
        <v-col cols="12" md="4" lg="3">
          <ClientSide />
        </v-col>

        <v-col cols="12" md="8" lg="9">
          <v-card class="pa-2" outlined tile height="100%">
            <v-data-table
              :headers="headers"
              :items="providers"
              sort-by="Name"
              sort-asc
              :loading="isLoading"
              loading-text="Loading Providers..."
              :search="search"
              height="auto"
            >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Providers</v-toolbar-title>
                <v-divider class="mx-2" inset vertical></v-divider>
                <v-spacer></v-spacer>

                <v-text-field
                  v-model="search"
                  clearable
                  flat
                  solo-inverted
                  hide-details
                  prepend-inner-icon="mdi-magnify"
                  label="Search"
                  class="flex-grow-1"
                ></v-text-field>

                <v-spacer></v-spacer>
                <v-btn v-if="canUpdate" color="#2b3990" dark @click="showAdd()">
                  <v-icon left>add</v-icon>
                  <span class="hidden-sm-and-down">Add Provider</span>
                  <span class="hidden-md-and-up">Add</span>
                </v-btn>
                <v-btn class="primary ml-3" @click="printTable()">
                  <v-icon small>print</v-icon>
                  <span class="hidden-sm-and-down">Print</span>
                </v-btn>
              </v-toolbar>
            </template>

            <!-- Action icons in the data table -->
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="viewProvider(item)">
                mdi-eye
              </v-icon>
              <v-icon small @click="deleteProvider(item)" v-if="canUpdate">
                mdi-delete
              </v-icon>
            </template>

            <template v-slot:no-data>
              <v-btn color="#2b3990" class="white--text" @click="getProviders()">
                Reset
              </v-btn>
            </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <Foot class="hideOnPrint" />

    <report-table
      :reportHeaderText="reportHeaderText"
      :tableHeaders="reportTableHeader"
      :tableData="reportData"
    />
  </div>
</template>


<script>
import axios from "axios";
import ClientNav from "../../components/ClientNav";
import ClientSide from "../../components/ClientSide";
import Foot from "../../components/Footer";
import {mapActions} from "vuex";
import ReportTable from '@/components/Report/ReportTable.vue';

const url = require("../../client_config/config").url;

export default {
    components: {
        ClientNav,
        ClientSide,
        Foot,
        ReportTable
    },
    data: function () {
        return {
            headers: [
                {
                    text: "Provider Name",
                    align: "start",
                    value: "Provider.Name",
                },
                {text: "Email", value: "Provider.Email"},
                {text: "Profession", value: "Provider.Profession"},
                {text: "Phone Number", value: "Provider.Phone"},
                {text: "Facility", value: "Provider.Company"},
                {text: "Address", value: "Provider.Address"},
                {text: "City", value: "Provider.City"},
                {text: "State", value: "Provider.State"},
                {text: "Zip", value: "Provider.Zip"},
                {text: "Actions", value: "actions", sortable: false},
            ],
            msg: false,
            search: "",
            text: "",
            providers: [],
            units: [],
            codes: [],
            tempData: [],
            unitID: localStorage.getItem("unitID"),
            clientID: this.$route.params.clientID,
            titleForm: "New Provider",
            providerID: "",
            newName: "",
            newEmail: "",
            newProfession: "",
            newCompany: "",
            newPhone: "",
            newFax: "",
            newAddress: "",
            newCity: "",
            newState: "",
            newZip: "",
            isLoading: true,
            globalProviders: [],
            newGlobalProvider: "",
            newStatus: "",
            newClients: [],
            listIndex: "",
            userState: localStorage.getItem("userState"),
        };
    },

    computed: {
        canUpdate() {
            if (
                localStorage.getItem("userRole") === "Administration" ||
                localStorage.getItem("userRole") === "Program Coordinator" ||
                localStorage.getItem("userRole") === "Compliance Manager" ||
                localStorage.getItem("userRole") === "Human Resources" ||
                localStorage.getItem("userRole") === "Client Services Manager" ||
                localStorage.getItem("userRole") === "Medical Manager"
            ) {
                return true;
            }
            return false;
        },

        reportHeaderText() {
            return 'Client Providers';
        },
        reportData() {
            return this.providers
        },
        reportTableHeader() {
            return this.headers.slice(0, this.headers.length-1);
        },
        isAuditorRole() {
            return localStorage.getItem("userRole") === 'Auditor'
        }
    },

    watch: {},

    created() {
        this.getProviders();
        this.getGlobalProviders();
    },

    methods: {
        ...mapActions({
            getClientProviders: "clientProviders/getItem",
            addItem: "clientProviders/addItem",
            updateItem: "clientProviders/updateItem",
            deleteItem: "clientProviders/deleteItem",
        }),

        initialize() {
            this.providers = [];
        },

        viewProvider(item) {
            this.$router.push({
                path: `/providers/${this.clientID}/update/${item._id}`,
                query: {createProvider: false}
            })
        },

        showAdd() {
            this.$router.push({
                path: `/providers/${this.clientID}/new`,
                query: {createProvider: true}
            })
        },

        async providerDelete(id) {
            try {
                await this.deleteItem(id);
                await this.getProviders();
                this.msg = true;
                this.text = "The provider has been deleted successfully.";
            } catch (e) {
                this.msg = true;
                this.text = "An Error has occurred while deleting the provider";
            }
        },

        deleteProvider(item) {
            const confirmed = confirm(
                "Are you sure you want to delete this provider from this client?"
            );

            if (confirmed) {
                this.providerDelete(item._id);
            }
        },

        async getProviders() {
            const response = await this.getClientProviders(this.clientID);
            this.providers = response.data;
        },

        getGlobalProviders: function () {
            this.isLoading = true;
            axios
                .get(`${url}/providers`)
                .then((res) => {
                    this.globalProviders = res.data.providers;
                })
                .finally(() => (this.isLoading = false));
        },

        printTable() {
            document.getElementById('printTable').style.display = "block";
            window.print()
            document.getElementById('printTable').style.display = "none";
        }

    },
};
</script>
<style>
#printTable{
    display: none;
}
@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }
}

@media print {
    #printTable {
      display: block;
      border: none;
      width: 1200px;
      padding-right: 300px;
      margin-left: -200px;
    }

    .hideOnPrint {
      display: none;
      border: none;
    }

    nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
      display: none;
      border: none;

    }

    @page { margin: 0; }
    body { margin: 1.6cm; }
}
</style>
